import {
    SETTING_POST_REQUEST,
    SETTING_POST_SUCCESS,
    SETTING_POST_FAIL,
    ADD_SURAH_SUCCESS,
    ADD_SURAH_FAIL,
    ADD_SURAH_REQUEST,
    GET_SURAH_SUCCESS,
    GET_SURAH_FAIL,
    GET_SURAH_REQUEST,
    EDIT_REVIEW_SUCCESS,
    EDIT_REVIEW_FAIL,
    EDIT_REVIEW_REQUEST,
    SHIFT_TOMORROW_TODAY_SUCCESS,
    SHIFT_TOMORROW_TODAY_FAIL,
    SHIFT_TOMORROW_TODAY_REQUEST,
    DELETE_REVIEW_SUCCESS,
    DELETE_REVIEW_REQUEST,
    DELETE_REVIEW_FAIL,
    POSTPONE_TODAY_SUCCESS,
    POSTPONE_TODAY_REQUEST,
    POSTPONE_TODAY_FAIL,
    POSTPONE_ALL_REVIEW_SUCCESS,
    POSTPONE_ALL_REVIEW_REQUEST,
    POSTPONE_ALL_REVIEW_FAIL,
    CHANGE_ALL_SURAH_TO_REVIEW_SUCESS,
    CHANGE_ALL_SURAH_TO_REVIEW_FAIL,
    CHANGE_ALL_SURAH_TO_REVIEW_REQUEST,
    SAVE_SURAH_AS_COMPLETE_SUCCESS,
    SAVE_SURAH_AS_COMPLETE_REQUEST,
    SAVE_SURAH_AS_COMPLETE_FAIL,
    GET_REVIEW_SURAHS_SUMMARY_SUCCESS,
    GET_REVIEW_SURAHS_SUMMARY_FAIL,
    GET_REVIEW_SURAHS_SUMMARY_REQUEST,
    GET_STATISTICS_SUCCESS,
    GET_STATISTICS_FAIL,
    GET_STATISTICS_REQUEST
} from '../actions/types';


const initialState = {
    settings: null,
    loading: false,
    error: null,
    review: {
        memorize_data: [],
        review_data: [],
      },
    reviewSummary: [],
    statistics: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SHIFT_TOMORROW_TODAY_SUCCESS:
            return {
                ...state,
                loading: false,
                // review: state.review.map(item =>
                //     item.review_id === payload.review_id ? { ...item, ...payload } : item
                // ),
                review: {
                    memorize_data: state.review.memorize_data.map(item =>
                        item.review_id === payload.review_id ? { ...item, ...payload } : item
                    ),
                    review_data: state.review.review_data.map(item =>
                        item.review_id === payload.review_id ? { ...item, ...payload } : item
                    ),
                },
            };
        case CHANGE_ALL_SURAH_TO_REVIEW_SUCESS:
            return {
                ...state,
                loading: false,
                // review: state.review.map(item =>
                //     item.review_id === payload.review_id ? { ...item, ...payload } : item
                // ),
                review: {
                    memorize_data: state.review.memorize_data.map(item =>
                        item.review_id === payload.review_id ? { ...item, ...payload } : item
                    ),
                    review_data: state.review.review_data.map(item =>
                        item.review_id === payload.review_id ? { ...item, ...payload } : item
                    ),
                },
            // };
            };
        case SAVE_SURAH_AS_COMPLETE_SUCCESS:
        case DELETE_REVIEW_SUCCESS:
        case POSTPONE_ALL_REVIEW_SUCCESS:
        case POSTPONE_TODAY_SUCCESS:
            return {
                ...state,
                loading: false,
                // review: state.review.filter(item => item.review_id !== payload.review_id),
                review: {
                    memorize_data: state.review.memorize_data.filter(item => item.review_id !== payload.review_id),
                    review_data: state.review.review_data.filter(item => item.review_id !== payload.review_id),
                },
            };
        
        case SETTING_POST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case SETTING_POST_SUCCESS:
            return {
                ...state,
                settings: payload,
                loading: false,
            };

        case ADD_SURAH_SUCCESS:
            return {
                ...state,
                loading: false,
                // review: [...state.review, payload],
                review: {
                    memorize_data: [...state.review.memorize_data, payload],
                    review_data: state.review.review_data,
                },
            // };
            };

        case GET_SURAH_SUCCESS:
            return {
                ...state,
                loading: false,
                review: {
                // Initialize both sub-arrays from payload
                memorize_data: Array.isArray(action.payload.memorize_data)
                    ? action.payload.memorize_data
                    : [],
                review_data: Array.isArray(action.payload.review_data)
                    ? action.payload.review_data
                    : [],
                },
            };

            case EDIT_REVIEW_SUCCESS: {
                const updated = action.payload;
                // state.review is an object, so calling state.review.map() fails
                // Instead, update the two arrays based on updated.review_status
                if (updated.review_status) {
                  // move item to review_data
                  return {
                    ...state,
                    loading: false,
                    review: {
                        memorize_data: state.review.memorize_data.map(item =>
                            item.review_id === updated.review_id ? { ...item, ...updated } : item
                          ),
                          review_data: state.review.review_data.map(item =>
                            item.review_id === updated.review_id ? { ...item, ...updated } : item
                          ),
                    },
                  };
                }
                // else move back to memorize_data
                return {
                  ...state,
                  loading: false,
                  review: {
                    memorize_data: [
                      ...state.review.memorize_data.filter(
                        item => item.review_id !== updated.review_id
                      ),
                      updated,
                    ],
                    review_data: state.review.review_data.filter(
                      item => item.review_id !== updated.review_id
                    ),
                  },
                };
              } 
        case GET_REVIEW_SURAHS_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                reviewSummary: payload,
            };
        case GET_STATISTICS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                statistics: payload,
            };
        case GET_STATISTICS_REQUEST:
        case GET_REVIEW_SURAHS_SUMMARY_REQUEST:
        case DELETE_REVIEW_REQUEST:
        case SAVE_SURAH_AS_COMPLETE_REQUEST:
        case POSTPONE_ALL_REVIEW_REQUEST:
        case POSTPONE_TODAY_REQUEST:
        case SHIFT_TOMORROW_TODAY_REQUEST:
        case SETTING_POST_REQUEST:
        case ADD_SURAH_REQUEST:   
        case CHANGE_ALL_SURAH_TO_REVIEW_REQUEST:
        case GET_SURAH_REQUEST:   
        case EDIT_REVIEW_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_STATISTICS_FAIL:
        case GET_REVIEW_SURAHS_SUMMARY_FAIL:
        case POSTPONE_TODAY_FAIL:
        case POSTPONE_ALL_REVIEW_FAIL:
        case DELETE_REVIEW_FAIL:
        case SHIFT_TOMORROW_TODAY_FAIL:
        case EDIT_REVIEW_FAIL:
        case GET_SURAH_FAIL:
        case ADD_SURAH_FAIL:
        case SETTING_POST_FAIL:
        case CHANGE_ALL_SURAH_TO_REVIEW_FAIL:
        case SAVE_SURAH_AS_COMPLETE_FAIL:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        default:
            return state;
    }
}